<template>
  <div>
    <header>
      <v-toolbar class="app-header elevation-0" fixed app>
        <router-link tag="div" :to="{ name: 'currentEvent' }">
          <v-toolbar-title>
              <div class="logo-img">
                <img draggable="false" src="~@/assets/logo.png">
              </div>
            <span>Messaging Application</span>
          </v-toolbar-title>
        </router-link>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <router-link 
            tag="v-btn" 
            class="btn--flat" 
            :to="{ name: 'currentEvent' }">
            <v-icon color="primary" class="nav-icons">home</v-icon>
            Home
          </router-link>
          <v-menu 
            v-if="$route.name !== 'logIn' && $route.name !== 'forgotPassword' && $route.name !== 'newPassword'"
            transition="slide-y-transition"
            class="ml-3 mr-3">
            <v-toolbar-side-icon slot="activator"><v-icon color="primary">person</v-icon></v-toolbar-side-icon>
            <v-list column>  
             <v-btn
               class="btn--flat"  
               @click="logout()"
               ><v-icon left light color="primary">exit_to_app</v-icon>
               Logout
             </v-btn>
             <v-btn
               class="btn--flat"
               :to="{ name: 'profile' }">
               <v-icon left light color="primary">edit</v-icon>
               Edit Profile
             </v-btn>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-toolbar>
    </header>
    <main>
      <v-container fluid grid-list-xl class="content-header">
          <v-flex xs12 sm10 offset-sm1>
            <v-layout row wrap justify-space-between>
              <div>
                <h3 class="headline mb-0">Message List</h3>
              </div>
              <v-layout row wrap justify-end>
                <div class="section-select">
                  <v-select
                    :items="sectionNames"
                    v-model="chosenSection"
                    @change="changeSection"
                    v-if="sectionNames.length > 0"
                    label="All sections"
                    color="primary"
                  ></v-select>
                </div>
                <router-link tag="v-btn"
                  :to="{ name: 'messageConfigNew', query: { section: $route.params.id } }"
                  class="primary white--text"
                >
                  <v-icon left dark>add</v-icon>
                  Add Message
                </router-link>
              </v-layout>
            </v-layout>
          </v-flex>
      </v-container>
        <v-flex xs12 sm10 offset-sm1 v-for="(message, index) in messages" :key="message._id">
          <v-layout row class="flex-row section-message-single">
            <div class="event-title">
              <h3 class="headline mb-0">{{message.name}}</h3>
              <span>{{message.date}}</span>  
            </div>
            <div class="message-img">
              <img draggable="false" :src="`${$store.state.baseUrl}${message.thumbnail}`">
            </div>
            <div class="right">
              <v-btn fab dark small color="primary" @click.stop="editMessage(message._id)">
                <v-icon dark>edit</v-icon>
              </v-btn>
              <v-btn fab dark small color="accent" @click.stop="deleteMessage(message._id, index)">
                <v-icon dark>close</v-icon>
              </v-btn>
            </div>
          </v-layout>
        </v-flex>
      <v-alert color="error" icon="warning" v-if="err" :value="err !== ''">{{err}}</v-alert>
    </main>

    <v-dialog v-model="dialogDelete" max-width="500px">
      <delete-modal modalType="Message" path="message" :id="deleteId" v-if="dialogDelete" @close="dialogDelete = false" @submit="submitDelete"></delete-modal>
    </v-dialog>
  </div>
</template>

<script>
  import moment from 'moment';
  import webHelper from '../../helpers/web';
  import Delete from '../modals/Delete';
  import Header from '../modules/Header';

  export default {
    data: () => ({
      err: '',
      sections: [],
      sectionNames: [],
      chosenSection: {},
      messages: [],
      events: [],
      dialogDelete: false,
    }),
    methods: {
      editMessage(id) {
        this.$router.push({ name: 'messageConfig', params: { id } });
      },
      async logout() {
        const path = process.env.NODE_ENV === 'development' ?
          'http://localhost:3000/logout' : '/logout';
        await webHelper.post(this, path, {});
        this.$store.state.logout();
        this.$router.push({ name: 'logIn' });
      },
      deleteMessage(id, index) {
        this.deleteId = id;
        this.deleteIndex = index;
        this.dialogDelete = true;
      },
      submitDelete() {
        this.messages.splice(this.deleteIndex, 1);
        this.deleteIndex = null;
        this.deleteId = null;
        this.dialogDelete = false;
      },
      changeSection(event) {
        const { _id: id } = this.sections.find(section => section.name === event);
        this.$router.push({ name: 'sectionMessages', params: { id } });
      },
      getType(type) {
        switch (parseInt(type, 10)) {
          case 0:
            return 'NFL';
          case 1:
            return 'NCAA';
          case 2:
          default:
            return 'Other';
        }
      },
      async populateSection() {
        const res = await webHelper.get(this, 'section');
        if (res.failed) {
          this.err = 'Failed to get sections';
          return;
        }
        this.sections = res.sections;
        this.sectionNames = res.sections.map(section => section.name);
        if (this.$route.params.id) {
          const { name } = this.sections.find(section => section._id === this.$route.params.id);
          this.chosenSection = name;
        }
        const where = this.$route.params.id ? { section: this.$route.params.id } : {};
        const res2 = await webHelper.get(this, 'message', where);
        const format = 'YYYY-MM-DD HH:mm';
        this.messages = res2.messages.map((current) => {
          const message = current;
          message.events = message.events
            .filter(event => !!event)
            .sort((a, b) =>
              new Date(a.start) - new Date(b.start));

          // Add message date
          if (message.events.length > 0) {
            message.date = message.events.length > 1 ?
              `${moment(message.events[0].start).format(format)}, ${moment(message.events[1].start).format(format)}...` :
              moment(message.events[0].start).format(format);
          }

          // Add message name
          const types = [];
          message.events.forEach((event) => {
            if (!types.includes(event.type)) {
              types.push(event.type);
            }
          });
          if (types.length === 1) {
            message.name = `${this.getType(types[0])} ${message.events.length === 1 ? 'game' : 'games'}`;
          } else {
            message.name = 'TEAM vs TEAM';
          }
          return message;
        });
      },
    },
    created() {
      this.populateSection();
    },
    watch: {
      $route() {
        this.populateSection();
      },
    },
    components: {
      deleteModal: Delete,
      appHeader: Header,
    },
  };
</script>


<style scoped lang="scss">
  .section-select {
    width: 275px;
    max-width: 100%;
  }
  .section-message-single {
    background-color: #f1f1f1;
    border: 1px solid rgba(0,0,0, 0.12);
    padding: 15px;
    margin-bottom: 20px;
  }
  .event-title {
    margin-right: auto;
    min-width: 240px;
    span {
      display: block;
    }
  }
  .message-img {
    width: 20%;
    margin: 0 auto;
    overflow: hidden;
    height: auto;
    padding-top: 11%;
    position: relative;
    img {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      max-width: 100%;
      height: auto;
    }
  }
  main {
    padding-top: 64px !important;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .padding-off {
    padding: 0 !important;
  }
  @media only screen and (max-width: 600px) {
    .headline {
      font-size: 15px !important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/messages/SectionMessages.vue